import { render, staticRenderFns } from "./OnlyOfficeViewer.vue?vue&type=template&id=3de44ee8&scoped=true"
import script from "./OnlyOfficeViewer.vue?vue&type=script&lang=js"
export * from "./OnlyOfficeViewer.vue?vue&type=script&lang=js"
import style0 from "./OnlyOfficeViewer.vue?vue&type=style&index=0&id=3de44ee8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de44ee8",
  null
  
)

export default component.exports